import React from 'react';
import PopUpContactUs from '../../../ContactUs/PopUpContactUs';
import PrintButton from 'components/PrintButton';
import ShareButton from 'components/ShareButton';
import iconClose from 'public/images/close.svg';
import Image from 'next/legacy/image';

export type GalleryPopupHeaderProps = {
  name: string;
  stats: string[];
  onClose?: () => void;
};

const GalleryPopupHeader: React.FC<GalleryPopupHeaderProps> = ({
  name,
  stats,
  onClose,
}) => (
  <div className="relative border-b border-dashed md:border-none pb-2 md:pb-0">
    <div className="container-1280 pl-[20px] pr-[20px] md:pl-[44px] md:pr-[44px] w-full min-h-[59px] md:pt-5 md:pb-5 pb-0 flex flex-col md:flex-row items-start md:items-center">
      <div className="flex pb-3 md:pb-0 pt-3 md:pt-0 justify-between w-full text-center flex-row md:flex-col">
        <div className="flex flex-col items-start xl:flex-row xl:items-center h-full">
          <h1 className="text-20-28-0.3 leading-5 m-0 xl:border-dashed-normal pr-7 h-full flex items-center font-sohneKraftig">
            {name}
          </h1>
          <ul className="hidden md:flex items-center gap-x-2 xl:gap-x-4 pl-0 xl:pl-7 mt-3 xl:mt-0 justify-center xl:justify-start">
            {stats.map((stat, idx) => (
              <li key={idx} className={`text-16-18-0.3 font-helvetica`}>
                {stat}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div
        className="flex items-center pr-5 md:absolute md:right-0 md:top-0 md:pr-0 xl:pr-0"
        style={{
          height: 'calc(100% - 8px)',
        }}
      >
        <div className="flex items-end justify-end gap-x-4 md:hidden lg:flex">
          <PrintButton />
          <ShareButton />
        </div>
        <div className="hidden md:block">
          <PopUpContactUs />
        </div>
        {onClose && (
          <button
            className="absolute right-2 top-2 block md:hidden"
            onClick={onClose}
          >
            <Image src={iconClose} alt="close popup" width={28} height={28} />
          </button>
        )}
      </div>
    </div>
    <div
      className="hidden md:block w-full h-2"
      style={{
        height: '8px',
        background:
          'linear-gradient(180deg, rgba(0,0,0,0.09) 0%, rgba(0,0,0,0) 100%)',
      }}
    />
  </div>
);

export default GalleryPopupHeader;
